module.exports = __webpack_public_path__ + "img/wrong.c2f61fe7.png";